export const appVersion = '0.37.0';
